import { ChangeEvent, useId, useLayoutEffect, useRef } from 'react';
import * as S from './styles';

export interface ChipItem {
  text: string;
  value: string;
}

interface Props {
  options: ChipItem[];
  selectedValue?: string;
  onChange?: (value: string) => void;
}

export default function ChipButtons({
  options,
  selectedValue,
  onChange
}: Props) {
  const radioName = useId();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (onChange) {
      onChange(value);
    }
  };

  const wrapperRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (options?.length < 1 || !wrapperRef.current) return;

    if (selectedValue) {
      setTimeout(() => {
        const optionIndex = options.findIndex(
          item => item.value === selectedValue
        );
        if (optionIndex === -1 || optionIndex === 0) return;

        const optionElement = document.getElementById(
          `chip-item-${selectedValue}`
        );
        if (optionElement) {
          wrapperRef.current!.scrollLeft =
            optionElement.offsetLeft - wrapperRef.current!.offsetLeft - 30;
          // wrapperRef.current!.scrollTo({
          //   left:
          //     optionElement.offsetLeft - wrapperRef.current!.offsetLeft - 30,
          //   behavior: 'smooth'
          // });
        }
      }, 750);
    }
  }, [options]);

  if (options?.length === 0) {
    return null;
  }

  return (
    <S.Wrapper ref={wrapperRef}>
      {options.map(item => (
        <S.ChipItem
          key={`chip-item-${item.value}`}
          id={`chip-item-${item.value}`}
        >
          <S.Input
            type="radio"
            id={`chip-${item.value}`}
            name={radioName}
            value={item.value}
            checked={selectedValue === item.value}
            onChange={handleChange}
          />
          <S.ChipButton htmlFor={`chip-${item.value}`}>
            {item.text}
          </S.ChipButton>
        </S.ChipItem>
      ))}
    </S.Wrapper>
  );
}
